import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-profile-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './profile-icon.component.html',
  styleUrls: ['./profile-icon.component.css']
})
export class ProfileIconComponent implements OnInit, OnDestroy {
  initial: string = '';
  private destroy$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.authService.userAuth
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: any) => {
        if (user) {
          if (user.displayName) {
             this.initial = user.displayName.charAt(0).toUpperCase();
          } else if (user.email) {
             this.initial = user.email.charAt(0).toUpperCase();
          } else {
             this.initial = 'U';
          }
        }
      });
  }

  goToProfile(): void {
    this.router.navigate(['/perfil']);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
